<template>
  <div class="dashboard">
    <!-- 第一部分：总数据 -->
    <section class="section overall-data">
      <h2>总数据</h2>
      <div class="card-row" >
        <div
          v-for="(item, index) in overallData"
          :key="'overall' + index"
          class="card-item"
        >
          <el-card class="data-card">
            <div class="data-title">{{ item.title }}</div>
            <div class="data-value" >{{ item.value }}</div>
          </el-card>
        </div>
      </div>
    </section>

    <!-- 第二部分：浙江数据 -->
    <section class="section region-data">
      <h2>浙江数据</h2>
      <div class="card-row">
        <div
          v-for="(item, index) in zhejiangData"
          :key="'zj' + index"
          class="card-item"
        >
          <el-card class="data-card">
            <div class="data-title">{{ item.title }}</div>
            <div class="data-value">{{ item.value }}</div>
          </el-card>
        </div>
      </div>
    </section>

    <!-- 第三部分：福建数据 -->
    <section class="section region-data">
      <h2>福建数据</h2>
      <div class="card-row">
        <div
          v-for="(item, index) in fujianData"
          :key="'fj' + index"
          class="card-item"
        >
          <el-card class="data-card">
            <div class="data-title">{{ item.title }}</div>
            <div class="data-value">{{ item.value }}</div>
          </el-card>
        </div>
      </div>
    </section>

    <!-- 第四部分：浙江部分客户数据 -->
    <section class="section customer-data">
      <h2>部分客户数据</h2>
      <el-table :data="zjCustomerData" stripe style="width: 100%">
        <el-table-column prop="uname" label="用户名"  style="width: 30%"></el-table-column>
        <el-table-column prop="todayConsume" label="今日消费" style="width: 30%" sortable></el-table-column>
        <el-table-column prop="yesConsume" label="昨日消费" style="width: 30%" sortable></el-table-column>
        <el-table-column prop="diff" label="消耗差"></el-table-column>
<!--        <el-table-column prop="chain" label="环比"></el-table-column>-->
      </el-table>
    </section>

    <!-- 第五部分：福建部分客户数据 -->
<!--    <section class="section customer-data">-->
<!--      <h2>福建部分客户数据</h2>-->
<!--      <el-table :data="fjCustomerData" stripe style="width: 100%">-->
<!--        <el-table-column prop="uname" label="用户名"  style="width: 30%"></el-table-column>-->
<!--        <el-table-column prop="todayConsume" label="今日消费" style="width: 30%" sortable></el-table-column>-->
<!--        <el-table-column prop="yesConsume" label="昨日消费" style="width: 30%" sortable></el-table-column>-->
<!--        <el-table-column prop="diff" label="消耗差"></el-table-column>-->
<!--&lt;!&ndash;        <el-table-column prop="chain" label="环比"></el-table-column>&ndash;&gt;-->
<!--      </el-table>-->
<!--    </section>-->
  </div>
</template>

<script>
import axios from "axios";
const Big = require('big.js');

export default {
  name: "Dashboard",
  data() {
    return {
      // 第一部分：总数据（默认数据，可后续替换 API 获取的数据）
      overallData: [
        { title: "今日数据", value: 0 },
        { title: "昨日数据", value: 0 },
        { title: "消费差", value: 0 },
        { title: "环比(%)", value: "0" }
      ],
      // 第二部分：浙江数据
      zhejiangData: [
        { title: "今日数据", value: 0 },
        { title: "昨日数据", value: 0 },
        { title: "消费差", value: 0 },
        { title: "环比(%)", value: "0" }
      ],
      // 第三部分：福建数据
      fujianData: [
        { title: "今日数据", value: 0 },
        { title: "昨日数据", value: 0 },
        { title: "消费差", value: 0 },
        { title: "环比(%)", value: "0" }
      ],
      // 模拟从接口获取的浙江客户参数（第四部分需要使用的参数）
      zjusers: [
        { uname: "点众短剧", uaccounts: ["dianzh"] },
        { uname: "挖财", uaccounts: ["ZJwacai"] },
        { uname: "众安", uaccounts: ["zjzabx"] },

        { uname: "踏歌行", uaccounts: ["HZyangsheng"] },
        { uname: "木易", uaccounts: ["FJyangsheng"] },
        { uname: "千堆雪", uaccounts: ["qianduxue"] },
        { uname: "追书", uaccounts: ["zjzhuishu"] },
        { uname: "生米", uaccounts: ["shengmi"] },
        { uname: "爱测评", uaccounts: ["tjfeimao"] }
      ],
      // 模拟福建客户参数（第五部分）
      fjusers: [
        { uname: "千堆雪", uaccounts: ["qianduxue3"] },
        { uname: "追书", uaccounts: ["fjzhuishu"] },
        { uname: "生米", uaccounts: ["shengmi2"] },
        { uname: "爱测评", uaccounts: ["tjfeimao1"] }
      ],
      // 用于表格展示的客户数据，实际数据应通过接口获取，这里先用随机数据
      zjCustomerData: [],
      fjCustomerData: [],
      todayAll: [], // 今日数据
      yesAll: [],   // 昨日数据
      result: [],   // zj处理后的结果
      fjresult: [],   // fj处理后的结果

      zjcookie:'',
      fjcookie:''

    };
  },
  created() {
    this.fetchHdCookieData();

  },
  methods: {
    async  fetchHdCookieData() {
      const pageNum = 1;
      const uid = 1;
      const role = 1;
      const pageSize = 10;
      const name = ''; // 根据需要修改此参数
      const url = `https://control.zjwec.cn/api/hdcookie/page?pageNum=${pageNum}&uid=${uid}&role=${role}&pageSize=${pageSize}&name=${encodeURIComponent(name)}`;
      try {
        const response = await axios.get(url);
        console.log('数据获取成功:', response.data);
        this.zjcookie = response.data.data.records[0].hdcookie
        this.fjcookie = response.data.data.records[1].hdcookie
        await       this.fetchCustomerData();

        await       this.getFJData();

        await       this.getZJData();
        // 这里可以处理返回的数据，例如更新到状态管理或组件
      } catch (error) {
        console.error('错误:', error);
      }
    },
    // 模拟接口请求，生成随机的客户消耗数据
    // fetchCustomerData() {
    //   this.$message.warning('数据查询中，请耐心等候...', 6000);
    //   // 创建多个请求的 Promise
    //   const zjTodayDataPromise = axios.get("https://control.zjwec.cn/api/vivo/getToDayData", {
    //     params: { cookie: this.zjcookie }
    //   });
    //
    //   const fjTodayDataPromise = axios.get("https://control.zjwec.cn/api/vivo/getToDayData", {
    //     params: { cookie: this.fjcookie }
    //   });
    //
    //   const zjYesDayDataPromise = axios.get("https://control.zjwec.cn/api/vivo/getYesDayData", {
    //     params: { cookie: this.zjcookie }
    //   });
    //
    //   const fjYesDayDataPromise = axios.get("https://control.zjwec.cn/api/vivo/getYesDayData", {
    //     params: { cookie: this.fjcookie }
    //   });
    //
    //   // 等待所有请求完成
    //   Promise.all([zjTodayDataPromise, fjTodayDataPromise, zjYesDayDataPromise, fjYesDayDataPromise])
    //     .then(responses => {
    //       // 处理浙江今日数据
    //       this.zhejiangData[0].value = new Big(responses[0].data.data.totalConsume).toFixed(2);
    //       this.zhejiangData[3].value = new Big(responses[0].data.data.totalConsumeHb).toFixed(2);
    //
    //       // 处理福建今日数据
    //       this.fujianData[0].value = new Big(responses[1].data.data.totalConsume).toFixed(2);
    //       this.fujianData[3].value = new Big(responses[1].data.data.totalConsumeHb).toFixed(2);
    //
    //       // 处理浙江昨日数据
    //       this.zhejiangData[1].value = new Big(responses[2].data.data.totalConsume).toFixed(2);
    //
    //       // 处理福建昨日数据
    //       this.fujianData[1].value = new Big(responses[3].data.data.totalConsume).toFixed(2);
    //
    //       // 计算消费差
    //       this.fujianData[2].value = new Big(this.fujianData[0].value).minus(this.fujianData[1].value).toFixed(2);
    //       this.zhejiangData[2].value = new Big(this.zhejiangData[0].value).minus(this.zhejiangData[1].value).toFixed(2);
    //
    //       // 计算总数据
    //       this.overallData[0].value = new Big(this.zhejiangData[0].value).plus(this.fujianData[0].value).toFixed(2);
    //       this.overallData[1].value = new Big(this.zhejiangData[1].value).plus(this.fujianData[1].value).toFixed(2);
    //       this.overallData[2].value = new Big(this.overallData[0].value).minus(this.overallData[1].value).toFixed(2);
    //       this.overallData[3].value = new Big(this.overallData[2].value*100).div(this.overallData[1].value).toFixed(2);
    //
    //       this.$message.success('查询完毕', 2000);
    //     })
    //     .catch(error => {
    //       console.error("请求失败", error);
    //     });
    // },

    fetchCustomerData() {

      Promise.all([
        // 第一次请求
        axios.get("https://control.zjwec.cn/api/mmxuser/subAccountList", {
          params: {
            cookie:this.zjcookie
          },
        }),

        // 第二次请求
        axios.get("https://control.zjwec.cn/api/mmxuser/subAccountList", {
          params: {
        cookie:this.fjcookie
         },
        })
      ]).then(([response1, response2]) => {
        // 初始化临时变量，用来存储每个请求的累加值
        let fujianToday = 0, fujianYesterday = 0;
        let zhejiangToday = 0, zhejiangYesterday = 0;

        // 处理第一次请求的返回数据
        if (Array.isArray(response1.data.fujianList)) {
          fujianToday += response1.data.fujianList.reduce((sum, item) => {
            return sum + (Math.floor(Number(item.todayConsumeAmount)) || 0); // Convert to integer
          }, 0);

          fujianYesterday += response1.data.fujianList.reduce((sum, item) => {
            return sum + (Math.floor(Number(item.yesterdayConsumeAmount)) || 0); // Convert to integer
          }, 0);
        }

        if (Array.isArray(response1.data.zhejiangList)) {
          zhejiangToday += response1.data.zhejiangList.reduce((sum, item) => {
            return sum + (Math.floor(Number(item.todayConsumeAmount)) || 0); // Convert to integer
          }, 0);

          zhejiangYesterday += response1.data.zhejiangList.reduce((sum, item) => {
            return sum + (Math.floor(Number(item.yesterdayConsumeAmount)) || 0); // Convert to integer
          }, 0);
        }

        // 处理第二次请求的返回数据
        if (Array.isArray(response2.data.fujianList)) {
          fujianToday += response2.data.fujianList.reduce((sum, item) => {
            return sum + (Math.floor(Number(item.todayConsumeAmount)) || 0); // Convert to integer
          }, 0);

          fujianYesterday += response2.data.fujianList.reduce((sum, item) => {
            return sum + (Math.floor(Number(item.yesterdayConsumeAmount)) || 0); // Convert to integer
          }, 0);
        }

        if (Array.isArray(response2.data.zhejiangList)) {
          zhejiangToday += response2.data.zhejiangList.reduce((sum, item) => {
            return sum + (Math.floor(Number(item.todayConsumeAmount)) || 0); // Convert to integer
          }, 0);

          zhejiangYesterday += response2.data.zhejiangList.reduce((sum, item) => {
            return sum + (Math.floor(Number(item.yesterdayConsumeAmount)) || 0); // Convert to integer
          }, 0);
        }

        this.zhejiangData[0].value= zhejiangToday
        this.zhejiangData[1].value= zhejiangYesterday
        this.zhejiangData[2].value= new Big(zhejiangToday).minus(zhejiangYesterday).toFixed(2);
        this.zhejiangData[3].value= new Big(this.zhejiangData[2].value*100).div(zhejiangYesterday).toFixed(2);


        this.fujianData[0].value= fujianToday
        this.fujianData[1].value= fujianYesterday
        this.fujianData[2].value= new Big(fujianToday).minus(fujianYesterday).toFixed(2);
        this.fujianData[3].value= new Big(this.zhejiangData[2].value*100).div(fujianYesterday).toFixed(2);


              this.overallData[0].value = new Big(this.zhejiangData[0].value).plus(this.fujianData[0].value).toFixed(2);
              this.overallData[1].value = new Big(this.zhejiangData[1].value).plus(this.fujianData[1].value).toFixed(2);
              this.overallData[2].value = new Big(this.overallData[0].value).minus(this.overallData[1].value).toFixed(2);
              this.overallData[3].value = new Big(this.overallData[2].value*100).div(this.overallData[1].value).toFixed(2);
      }).catch(error => {
        console.error('请求错误:', error);
      });
    },



    getZJData() {
      const fetchData = (url, cookie) => {
        return axios.get(url, { params: { cookie } }).then(res => res.data.adsAccountList);
      };
      // 使用 this.zjcookie 进行请求
      const cookie = this.zjcookie;
      Promise.all([
        fetchData("https://control.zjwec.cn/api/mmxuser/subAccountOverview", cookie),
        fetchData("https://control.zjwec.cn/api/mmxuser/subOverview", cookie)
      ])
        .then(([todayAll, yesAll]) => {
          this.todayAll = todayAll;
          this.yesAll = yesAll;

          this.result = this.zjusers.map(user => {
            const todayConsume = user.uaccounts.reduce((total, account) => {
              const accountData = this.todayAll.find(item => item.subAccountName === account);
              return total + (accountData ? Number(accountData.totalConsume) : 0);
            }, 0);

            const yesConsume = user.uaccounts.reduce((total, account) => {
              const accountData = this.yesAll.find(item => item.subAccountName === account);
              return total + (accountData ? Number(accountData.totalConsume) : 0);
            }, 0);

            return {
              uname: user.uname,
              todayConsume: Number(todayConsume.toFixed(2)),
              yesConsume: Number(yesConsume.toFixed(2))
            };
          });
          // 遍历 this.result 数组，计算 diff 和 chain，同时更新 todayConsume、yesConsume、diff
          this.result.forEach(user => {
            // 查找匹配的对象
            const matchingObj = this.fjresult.find(fjObj => fjObj.uname === user.uname);

            // 如果找到了对应的对象，则更新属性值
            if (matchingObj) {
              user.todayConsume = (user.todayConsume + matchingObj.todayConsume).toFixed(2);
              user.yesConsume = (user.yesConsume + matchingObj.yesConsume).toFixed(2);
              // user.diff = (user.diff + matchingObj.diff).toFixed(2);  // 如果需要对 diff 也进行相加
            }

            // 计算今日与昨日的差值
            user.diff = new Big(user.todayConsume).minus(user.yesConsume).toFixed(2);

            // 计算环比增长率，避免除以零的情况
            if (user.yesConsume !== 0) {
              user.chain = ((user.diff / user.yesConsume) * 100).toFixed(2) + '%';
            } else {
              user.chain = '——'; // 昨日消费为零时，环比显示为“——”
            }
          });

          this.zjCustomerData = this.result;
        })
        .catch(error => {
          console.error("请求数据时出错:", error);
        });
    },
    getFJData() {
      const fetchData = (url, cookie) => {
        return axios.get(url, { params: { cookie } }).then(res => res.data.adsAccountList);
      };
      // 使用 this.zjcookie 进行请求
      const cookie = this.fjcookie;
      Promise.all([
        fetchData("https://control.zjwec.cn/api/mmxuser/subAccountOverview", cookie),
        fetchData("https://control.zjwec.cn/api/mmxuser/subOverview", cookie)
      ])
        .then(([todayAll, yesAll]) => {
          this.todayAll = todayAll;
          this.yesAll = yesAll;

          this.fjresult = this.fjusers.map(user => {
            const todayConsume = user.uaccounts.reduce((total, account) => {
              const accountData = this.todayAll.find(item => item.subAccountName === account);
              return total + (accountData ? Number(accountData.totalConsume) : 0);
            }, 0);

            const yesConsume = user.uaccounts.reduce((total, account) => {
              const accountData = this.yesAll.find(item => item.subAccountName === account);
              return total + (accountData ? Number(accountData.totalConsume) : 0);
            }, 0);

            return {
              uname: user.uname,
              todayConsume: Number(todayConsume.toFixed(2)),
              yesConsume: Number(yesConsume.toFixed(2))
            };
          });
          this.fjresult.forEach(user => {
            // 计算今日与昨日的差值
            user.diff =  new Big( user.todayConsume).minus(user.yesConsume).toFixed(2);
            // 计算环比增长率，避免除以零的情况
            if (user.yesConsume !== 0) {
              user.chain = ((user.diff / user.yesConsume) * 100).toFixed(2) + '%';
            } else {
              user.chain = '——'; // 昨日消费为零时，环比显示为“——”
            }
          });
          // this.fjCustomerData = this.fjresult;

        })
        .catch(error => {
          console.error("请求数据时出错:", error);
        });
    },


  },

};
</script>

<style scoped>
.dashboard {
  padding: 20px;
  background: #f4f7fa;
}

/* 各部分公共样式 */
.section {
  margin-bottom: 30px;
}

.section h2 {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}

/* 三个数据区域卡片的容器及卡片样式 */
.card-row {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  /*padding: 0 10px;*/
}

.card-item {
  flex: 0 0 25%;
  box-sizing: border-box;
  /*padding: 0 10px;*/
}

/* 卡片内部样式 */
.data-card {
  text-align: center;
  background: linear-gradient(135deg, #00c6ff, #0072ff);
  color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.data-title {
  font-size: 16px;
  margin-bottom: 10px;
}

.data-value {
  font-size: 0.9em;
  font-weight: bold;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /*height: 40px; !* 固定高度 *!*/
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 显示 2 行 */
  -webkit-box-orient: vertical;
}

/* 表格样式调整 */
.el-table th,
.el-table td {
  text-align: center;
}

/* 手机端响应式调整：在小屏幕下保持一定的展示效果 */
@media (max-width: 768px) {
  .data-card {
    padding: 15px;
  }
  .section h2 {
    font-size: 18px;
  }
  /* 如果需要在手机端一次显示所有卡片，可考虑减小卡片宽度，或者允许横向滚动 */
  .card-item {
    flex: 0 0 50%;
    margin-bottom: 15px;
  }
  .card-row {
    flex-wrap: wrap;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/login/weichiAllData.vue